const getters = {
  jobcards: (state) => state.jobcards,
  jobId: (state) => state.jobId,
  jobDemand: (state) => state.jobDemand,
  jobFile: (state) => state.jobFile,
  JobcardPriority: (state) => state.JobcardPriority,
  loading: (state) => state.loading,
  jobcardsFiles: (state) => state.jobcardsFiles,
  jobcardsFile: (state) => state.jobcardsFile,
  timesheetList: (state) => state.timesheetList,
  timesheet: (state) => state.timesheet,
};

export default getters;
